import { render, staticRenderFns } from "./PriceInput.vue?vue&type=template&id=b11396e6&scoped=true"
import script from "./PriceInput.vue?vue&type=script&lang=js"
export * from "./PriceInput.vue?vue&type=script&lang=js"
import style0 from "./PriceInput.vue?vue&type=style&index=0&id=b11396e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b11396e6",
  null
  
)

export default component.exports